import React from 'react';
import { motion } from 'framer-motion';
import GitStatus from './GitStatus';

const Settings = ({ onNavigateToDashboard }) => {
    return (
        <div className="settings-page">
            <motion.div 
                className="container-fluid"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h2 className="mb-0">
                                <i className="bi bi-gear me-2"></i>
                                Settings
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {/* Git Repository Status */}
                    <motion.div 
                        className="col-lg-8 mb-4"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.2 }}
                    >
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-transparent border-0">
                                <h5 className="mb-0">
                                    <i className="bi bi-git me-2"></i>
                                    Git Repository Status
                                </h5>
                                <p className="text-muted mb-0 mt-2">
                                    Local repository used for navigation data to reduce Bitbucket API calls
                                </p>
                            </div>
                            <div className="card-body">
                                <GitStatus />
                            </div>
                        </div>
                    </motion.div>

                    {/* Quick Actions */}
                    <motion.div 
                        className="col-lg-4 mb-4"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.4 }}
                    >
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-transparent border-0">
                                <h5 className="mb-0">
                                    <i className="bi bi-lightning me-2"></i>
                                    Quick Actions
                                </h5>
                            </div>
                            <div className="card-body">
                                <div className="d-grid gap-3">
                                    <button 
                                        className="btn btn-outline-primary"
                                        onClick={() => window.location.reload()}
                                    >
                                        <i className="bi bi-arrow-clockwise me-2"></i>
                                        Refresh Page
                                    </button>
                                    
                                    <button 
                                        className="btn btn-outline-secondary"
                                        onClick={onNavigateToDashboard}
                                    >
                                        <i className="bi bi-arrow-left me-2"></i>
                                        Back to Dashboard
                                    </button>
                                    
                                    <button 
                                        className="btn btn-outline-info"
                                        onClick={() => window.open('/health', '_blank')}
                                    >
                                        <i className="bi bi-heart-pulse me-2"></i>
                                        Health Check
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Additional Settings Sections */}
                <motion.div 
                    className="row"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 }}
                >
                    <div className="col-12">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-transparent border-0">
                                <h5 className="mb-0">
                                    <i className="bi bi-info-circle me-2"></i>
                                    System Information
                                </h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h6 className="text-muted mb-3">Application Details</h6>
                                        <ul className="list-unstyled">
                                            <li className="mb-2">
                                                <strong>Name:</strong> Delivery Express
                                            </li>
                                            <li className="mb-2">
                                                <strong>Purpose:</strong> Infrastructure as Code Management
                                            </li>
                                            <li className="mb-2">
                                                <strong>Version:</strong> 1.0.0
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-6">
                                        <h6 className="text-muted mb-3">Features</h6>
                                        <ul className="list-unstyled">
                                            <li className="mb-2">
                                                <i className="bi bi-check-circle text-success me-2"></i>
                                                Infrastructure Navigation
                                            </li>
                                            <li className="mb-2">
                                                <i className="bi bi-check-circle text-success me-2"></i>
                                                Pipeline Management
                                            </li>
                                            <li className="mb-2">
                                                <i className="bi bi-check-circle text-success me-2"></i>
                                                Real-time Updates
                                            </li>
                                            <li className="mb-2">
                                                <i className="bi bi-check-circle text-success me-2"></i>
                                                Alert Management
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default Settings; 